import LoadingButton from "@mui/lab/LoadingButton";
import * as Yup from "yup";
import { useFormik } from "formik";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_URL, handleSendMessage } from "../../utilities";
import { useAuth } from "../../context/auth";
import { useNotifications } from "@toolpad/core/useNotifications";
import React, { useEffect, useState } from "react";
import TabService from "./components/tab-service";
import { IServiceItem } from "src/interface/IServiceItem";
import SkeltonProgress from "src/components/SkeltonProgress";
import { getRoutes } from "src/utilities/routes";
import { IService } from "src/interface/IService";

const validationSchema = Yup.object({
  rowId: Yup.string().required("این فیلد الزامی است"),
  name: Yup.string().required("این فیلد الزامی است"),
  price: Yup.string().required("این فیلد الزامی است"),
  serviceGroupId: Yup.number().when("isFollowUp", {
    is: "true",
    then: (schema) => schema.required("این فیلد الزامی است"),
    otherwise: (schema) => schema.optional(),
  }),
});

const initialValues = {
  rowId: undefined, // شماره ردیف
  name: "",
  price: undefined, // قیمت
  isFollowUp: "false", // نیاز به پیگیری دارد؟
  followUpType: undefined, // نوع پیگیری
  firstFollowUpedOn: undefined, // تاریخ اولین پیگیری
  alertDayLeft1: undefined, // چند روز مانده هشدار بدهد
  alertDayLeft2: undefined, // چند روز مانده هشدار بدهد
  alertDayLeft3: undefined, // چند روز مانده هشدار بدهد
  alertTimeAt: "", // چه ساعتی ارسال بشه
  isPayment: "false", // آیا پرداختی دارد؟
  alertDayLeftForPayment1: undefined, // چند روز مانده هشدار بدهد برای پرداخت
  alertDayLeftForPayment2: undefined, // چند روز مانده هشدار بدهد برای پرداخت
  alertTimeAtForPayment: "", // چه ساعتی ارسال بشه برای پرداخت
  sampleSMSPayment: "", // پیامک پرداخت
  systemRef: undefined, // سامانه مرتبط
  serviceGroupId: undefined, // اضافه کردن serviceGroupId به مقادیر اولیه
};

const NewService = ({
  open,
  handleClose,
  refetch,
  isEdit = false,
  serviceId,
  setServiceId,
}: {
  open: boolean;
  handleClose: () => void;
  refetch: any;
  isEdit: boolean;
  serviceId?: number;
  setServiceId: (serviceId?: number) => void;
}) => {
  const Routes = getRoutes();
  const { user } = useAuth();
  const { mutateAsync: insertAsync, isPending } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.ServicesRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.ServicesRoutes + body.id, {
        method: "PUT",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const { mutateAsync: getServiceItem } = useMutation({
    mutationFn: async (id: number) => {
      const response = await fetch(
        Routes.ServiceItemsRoutes + "byServiceRef/" + id,
        {
          method: "GET",
          headers: {
            Accept: "*/*",
            "Content-Type": "application/json-patch+json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );
      return await response.json();
    },
    onSuccess: (responseData: IServiceItem[]) => {
      responseData &&
        responseData.length > 0 &&
        setServiceItems(responseData?.sort((a: any, b: any) => a.id - b.id));
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log("eee", error);
    },
  });

  const [data, setData] = useState<IService>();

  const { mutate: getServiceById, isPending: isServiceByIdLoading } =
    useMutation({
      mutationFn: async (id: number) => {
        const response = await fetch(Routes.ServicesRoutes + id, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Aceept: "application/json",
          },
        });
        console.log("response", response);

        return await response.json();
      },
      onSuccess: (responseData: IService) => {
        if (responseData) {
          setData(responseData);
        }
      },
      onError: (error) => {
        notifications.show("خطا در دریافت اطلاعات", {
          severity: "error",
          autoHideDuration: 3000,
        });
        console.log(error);
      },
    });

  useEffect(() => {
    if (serviceId) getServiceById(serviceId);
  }, [serviceId]);

  useEffect(() => {
    if (data && isEdit) {
      formik.setValues(data as any);
      formik.setFieldValue("isFollowUp", data?.isFollowUp.toString());
      formik.setFieldValue("isPayment", data?.isPayment.toString());
      formik.setFieldValue("serviceGroupId", data?.serviceGroupId ?? "");
      data?.firstFollowUpedOn &&
        formik.setFieldValue(
          "firstFollowUpedOn",
          new Date(data?.firstFollowUpedOn)
        );

      getServiceItem(data.id);
    }
  }, [data]);

  const {
    mutateAsync: insertServiceItemAsync,
    isPending: isPendingServiceItem,
  } = useMutation({
    mutationFn: async (body: any) => {
      const response = await fetch(Routes.ServiceItemsRoutes, {
        method: "POST",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: updateServiceItemAsync,
    isPending: isPendingServiceItemEdit,
  } = useMutation({
    mutationFn: async (body: IServiceItem) => {
      const response = await fetch(Routes.ServiceItemsRoutes + body.id, {
        method: "Put",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
          Authorization: `Bearer ${user?.token}`,
        },
        body: JSON.stringify(body),
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const {
    mutateAsync: deleteServiceItemAsync,
    isPending: isDeleteServiceItemLoading,
  } = useMutation({
    mutationFn: async (id: number) => {
      const response = await fetch(Routes.ServiceItemsRoutes + id, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      });
      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });
  const notifications = useNotifications();
  const [serviceItems, setServiceItems] = useState<IServiceItem[]>([]);
  const formik = useFormik({
    initialValues, // مقادیر اولیه فرم
    validationSchema, // schema اعتبارسنجی
    onSubmit: async (values) => {
      // پاک کردن فیلدهای مربوط به پیگیری اگر isFollowUp = false
      let cleanedValues = { ...values };

      if (values.isFollowUp === "false") {
        cleanedValues = {
          ...cleanedValues,
          followUpType: undefined,
          firstFollowUpedOn: undefined,
          alertDayLeft1: undefined,
          alertDayLeft2: undefined,
          alertDayLeft3: undefined,
          alertTimeAt: "",
        };
      }

      // پاک کردن فیلدهای مربوط به پرداخت اگر isPayment = false
      if (values.isPayment === "false") {
        cleanedValues = {
          ...cleanedValues,
          alertDayLeftForPayment1: undefined,
          alertDayLeftForPayment2: undefined,
          alertTimeAtForPayment: "",
          sampleSMSPayment: "",
        };
      }

      const firstFollowUpedOn = cleanedValues.firstFollowUpedOn
        ? new Date(cleanedValues.firstFollowUpedOn)
        : undefined;

      let res: any;
      if (isEdit) {
        res = await updateAsync({
          ...cleanedValues,
          firstFollowUpedOn,
          id: data?.id,
        });
      } else {
        // TODO هشدار بدیم که روز تاریخ اولین پیگیری نباید از 30 بیشتر باشد
        // TODO اگر تاریخ خدمت عوض شد بره تمامی تاریخ شروع پیگیری های قرار داد های سال جاری رو عوض کنه

        res = await insertAsync({ ...cleanedValues, firstFollowUpedOn });
      }

      if (res.status === true) {
        if (isEdit && data?.serviceItems && data?.serviceItems?.length > 0) {
          // حذف خدماتی که از لیست آیتم خدمات حذف شده اند
          data?.serviceItems?.map(async (s: IServiceItem) => {
            if (!serviceItems.find((service) => service.id === s.id))
              await deleteServiceItemAsync(s.id as number);
          });
        }

        if (isEdit && serviceItems.length > 0) {
          serviceItems.map(async (item) => {
            // اگر آیتم خدمت در لیست آیتم های خدمت های دیتابیس وجود داشت آن را ویرایش کند
            if (
              data?.serviceItems?.find(
                (service: IServiceItem) => service.id === item.id
              )
            )
              await updateServiceItemAsync(item);
            // اگر آیتم خدمت در لیست آیتم های خدمت های دیتابیس وجود نداشت آن را اضافه کند
            else
              await insertServiceItemAsync({
                ...item,
                serviceRef: res.data?.id,
              });
          });
        }
        // اگر خدمت جدیدی اضافه شده بود
        else if (!isEdit && serviceItems.length > 0) {
          serviceItems.map(async (item) => {
            await insertServiceItemAsync({
              ...item,
              serviceRef: res.data?.id,
            });
          });
        }
        handleSendMessage(
          notifications,
          "خدمت جدید با موفقیت ثبت شد!",
          "success"
        );
        setServiceItems([]);
        handleClose();
      } else {
        handleSendMessage(notifications, "خطا در ذخیره سازی!", "error");
      }
      formik.resetForm();
      setServiceId(undefined);
      refetch();
    },
  });

  const Close = () => {
    handleClose();
    setServiceId(undefined);
    formik.resetForm();
    setServiceItems([]);
  };

  return (
    <React.Fragment>
      <Dialog
        open={open}
        onClose={Close}
        maxWidth="xl"
        PaperProps={{
          component: "form",
          onSubmit: formik.handleSubmit,
          sx: {
            width: "100%",
          },
        }}
      >
        <DialogTitle>
          {isEdit ? "ویرایش خدمت '" + data?.name + "'" : "خدمت جدید"}
        </DialogTitle>
        <DialogContent>
          {serviceId && isServiceByIdLoading ? (
            <SkeltonProgress />
          ) : (
            <TabService
              formik={formik}
              serviceItems={serviceItems}
              setServiceItems={setServiceItems}
            />
          )}
        </DialogContent>
        <DialogActions>
          <LoadingButton
            loading={
              isPending ||
              isPendingServiceItem ||
              isDeleteServiceItemLoading ||
              isEditLoading
            }
            variant="contained"
            color="success"
            size="medium"
            fullWidth
            type="submit"
          >
            ذخیره
          </LoadingButton>
          <Button color="error" variant="contained" onClick={Close}>
            انصراف
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default NewService;
